<template>
  <div class="app-login">
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <h1>Хоккейная команда</h1>
          <p>Вход в приложение</p>
        </div>

        <a-form
          :model="loginForm"
          @finish="handleLogin"
          layout="vertical"
          class="login-form"
        >
          <a-form-item
            label="Логин"
            name="login"
            :rules="[{ required: true, message: 'Введите логин' }]"
          >
            <a-input
              v-model:value="loginForm.login"
              placeholder="Введите логин"
              size="large"
              autocomplete="username"
            />
          </a-form-item>

          <a-form-item
            label="Пароль"
            name="password"
            :rules="[{ required: true, message: 'Введите пароль' }]"
          >
            <a-input-password
              v-model:value="loginForm.password"
              placeholder="Введите пароль"
              size="large"
              autocomplete="current-password"
            />
          </a-form-item>

          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              size="large"
              :loading="loading"
              block
            >
              Войти
            </a-button>
          </a-form-item>
        </a-form>

        <div v-if="error" class="error-message">
          {{ error }}
        </div>

        <div class="login-hint">
          <p>Чтобы войти в приложение вне Telegram, сначала откройте его через Telegram и установите логин и пароль в настройках профиля.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '../services/api';

export default {
  name: 'AppLogin',
  emits: ['login-success'],
  data() {
    return {
      loginForm: {
        login: '',
        password: ''
      },
      loading: false,
      error: ''
    };
  },
  methods: {
    async handleLogin() {
      this.loading = true;
      this.error = '';

      try {
        const data = await api.authenticateWithPassword(this.loginForm.login, this.loginForm.password);
        api.setToken(data.token);
        localStorage.setItem('webAuthToken', data.token);
        this.$emit('login-success', data);
      } catch (err) {
        this.error = err.message || 'Неверный логин или пароль';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.app-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--color-primary) 0%, #764ba2 100%);
  padding: var(--spacing-lg);
}

.login-container {
  width: 100%;
  max-width: 400px;
}

.login-card {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-xl);
  padding: var(--spacing-xxl);
  box-shadow: var(--shadow-lg);
}

.login-header {
  text-align: center;
  margin-bottom: var(--spacing-xl);
}

.login-header h1 {
  margin: 0 0 var(--spacing-xs) 0;
  font-size: var(--font-size-xxxl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.login-header p {
  margin: 0;
  color: var(--color-text-tertiary);
  font-size: var(--font-size-lg);
}

.login-form {
  margin-bottom: var(--spacing-lg);
}

.error-message {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  color: #cf1322;
  text-align: center;
  font-size: var(--font-size-md);
  margin-bottom: var(--spacing-md);
}

.login-hint {
  margin-top: var(--spacing-lg);
  padding: var(--spacing-md);
  background: var(--color-bg-secondary);
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: 1.4;
}

.login-hint p {
  margin: 0;
}

@media (max-width: 480px) {
  .login-card {
    padding: var(--spacing-xl);
  }
  .login-header h1 {
    font-size: var(--font-size-xl);
  }
}
</style>
